import SeoHead from "../components/SeoHead";
import CTABand from "../components/CTABand";
import { PageHeader } from "./Services";
import { FAQ, SITE } from "../lib/site";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../components/ui/accordion";

export default function FAQPage() {
  return (
    <div data-testid="faq-page">
      <SeoHead
        title="FAQ Termites Bordeaux & Gironde — 10 réponses d'expert | Termite Habitat 33"
        description="Réponses d'expert aux questions sur l'expertise obligatoire en Gironde, les coûts de traitement, les différences entre termites, vrillettes et capricornes."
        canonical={SITE.url + "/faq"}
        keywords={["FAQ termites Bordeaux", "questions termites Gironde"]}
        breadcrumbs={[
          { name: "Accueil", url: SITE.url + "/" },
          { name: "FAQ", url: SITE.url + "/faq" },
        ]}
        schema={{
          "@context": "https://schema.org",
          "@type": "FAQPage",
          mainEntity: FAQ.map((f) => ({
            "@type": "Question",
            name: f.q,
            acceptedAnswer: { "@type": "Answer", text: f.a },
          })),
        }}
      />
      <PageHeader
        eyebrow="Questions fréquentes"
        title="Tout ce qu'on nous demande sur les termites à Bordeaux."
        intro="L'expertise, les coûts, les délais, les garanties : les réponses claires de notre cabinet."
      />
      <section className="container-x py-16 max-w-3xl">
        <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
          {FAQ.map((f, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              className="border-b border-[#D5CABD] py-2"
              data-testid={`faq-item-${i}`}
            >
              <AccordionTrigger className="font-serif text-xl text-gray-900 hover:text-[#7A2E39] text-left">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-gray-700 text-[15px] leading-relaxed pt-2">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </section>
      <CTABand />
    </div>
  );
}
